import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import PlusIcon from "../../assets/icons/plus.svg2";
import boomColouredIcon from "../../assets/boom_coloured.png";
import TickIcon from "../../assets/icons/tick.svg2";
import LogicIcon from "../../assets/icons/library_logic.svg2";

import { Row } from "react-bootstrap";
import PurchaseOptions from "./SolutionPurchaseOptions";

function TemplateFeatures() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button
        className="btn btn-colored-reverse rounded-pill mt-4"
        size="m"
        onClick={handleShow}
      >
        <div className="d-flex align-items-center ">
          <PlusIcon width={25} className=" white rounded-circle p-1" />
          <span className="my-0 mx-3 fw-bold">VIEW ALL FEATURES </span>
        </div>
      </Button>

      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        style={{ width: 750 }}
      >
        <Offcanvas.Body className="bg-purple-gradient p-5">
          <div className=" p-3  position-relative mt-5 ">
            <span className="bg-colored-reverse rounded-pill text-spaced text-white px-4 small py-1 position-absolute top-0 start-50 translate-middle ">
              RECOMMENDED
            </span>
            <div className="text-center mt-4 mb-4">
              <span className="bg-icon rounded-circle py-3">
                <img src={boomColouredIcon} width={50} />
              </span>
            </div>

            <h1 className="fw-bold text-center">boomLogic Custom</h1>
            <div className="text-center m-auto w-75 ">
              <span className="text-secondary fs-5 fw-bold">
                A custom template our boomLogic system has created based on our
                responses.
              </span>
            </div>

            <div className="text-center   mt-4">
              <span className=" fw-bold bg-info rounded-pill text-white  px-3 py-2">
                <LogicIcon width={25} className="white " /> LOGIC READY
              </span>
            </div>

            <div className="text-center  px-1 py-3">
              <span className="fw-bold mb-3">
                This template will setup the following for you:
              </span>
            </div>
            <Row className="my-4">
              <div className=" d-flex mb-2 align-items-end col-6 ">
                <TickIcon width={20} className=" rounded-circle me-3" />
                <div>Lorem ipsum dolor sit amet consec</div>
              </div>
              <div className=" d-flex mb-2  align-items-end col-6 ">
                <TickIcon width={20} className=" rounded-circle me-3" />
                <div>Lorem ipsum dolor sit amet consec</div>
              </div>
              <div className=" d-flex mb-2  align-items-end col-6 ">
                <TickIcon width={20} className=" rounded-circle me-3" />
                <div>Lorem ipsum dolor sit amet consec</div>
              </div>
              <div className=" d-flex mb-2  align-items-end col-6 ">
                <TickIcon width={20} className=" rounded-circle me-3" />
                <div>Lorem ipsum dolor sit amet consec</div>
              </div>
              <div className=" d-flex mb-2  align-items-end col-6 ">
                <TickIcon width={20} className=" rounded-circle me-3" />
                <div>Lorem ipsum dolor sit amet consec</div>
              </div>
              <div className=" d-flex mb-2  align-items-end col-6 ">
                <TickIcon width={20} className=" rounded-circle me-3" />
                <div>Lorem ipsum dolor sit amet consec</div>
              </div>
              <div className=" d-flex mb-2  align-items-end col-6 ">
                <TickIcon width={20} className=" rounded-circle me-3" />
                <div>Lorem ipsum dolor sit amet consec</div>
              </div>
            </Row>

            <div>
              <div className="text-center  px-1 py-3">
                <span className="fw-bold">More about this template:</span>
              </div>

              <p>
                Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                Incidunt, voluptas doloribus ab id quaerat quae ea animi eaque
                minima eum ut, nostrum esse sint, quos sed ullam quibusdam
                suscipit facere! Lorem ipsum dolor, sit amet consectetur
                adipisicing elit. Adipisci quisquam a aspernatur dolore porro.
              </p>
              <p>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quia
                vero alias voluptates obcaecati error dolores expedita,
                praesentium accusamus ipsa nesciunt maxime libero voluptatem?
                Nisi nulla rem sunt? Eius, molestias repudiandae.
              </p>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                Dolorem at odio quod asperiores velit nesciunt inventore.
              </p>
              <p>
                Repellendus ipsa ea doloribus vitae vero possimus rem maiores,
                cum aspernatur perferendis ex corrupti.
              </p>
            </div>
            <div className="text-center ">
              <Button className="bg-black fw-bold  p-2 rounded-pill mt-4 ">
                <div className="d-flex align-items-center ">
                  <TickIcon width={25} className=" purple rounded-circle p-1" />
                  <span className="my-0 mx-3">
                    Apply Template & Start Build{" "}
                  </span>
                </div>
              </Button>
              <h6 className="text-secondary p-2">
                Lorem ipsum dolor sit amet consec
              </h6>
            </div>
          </div>
          <PurchaseOptions />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default TemplateFeatures;
